import React from "react";

const TextInput = ({ onChange, className, widthClassName, value, ...props }) => {
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`${className} ${widthClassName ? widthClassName : 'w-full'} relative bg-surface py-2 px-3 border border-border rounded placeholder:text-gray-secondary text-[14px] leading-6 text-gray-primary outline-primary-hover`}
      {...props}
    />
  );
};

export const NumberInput = (props) => {
  return <TextInput type="number" {...props} />;
};

export default TextInput;
